// AnalysisTopbar.jsx
import "./AnalysisTopbar.scss";

import { Badge, Col, Form, Row } from "react-bootstrap";
import React, { useEffect, useMemo, useState } from "react";

import AppButton from "../../../../../../commons/buttons/AppButton";
import AppInputV2 from "../../../../../../commons/inputs/AppInputV2";
import CalendarInputV2 from "../../../../../../commons/inputs/CalendarInputV2";
import dayjs from "dayjs";
import { formatDateInEN } from "../../../../../../commons/util/HallAppUtil";

export default function AnalysisTopbar({
  title,
  badgeVariant,
  badgeLabel,
  mode,
  onChangeMode,
  onReset,

  analysisName,
  setAnalysisName,

  analysisDate,
  setAnalysisDate,

  onSave,
  canSave,
}) {
  // CalendarInputV2 usa Date
  const [startDate, setStartDate] = useState(() => {
    if (analysisDate) return dayjs(analysisDate).toDate();
    return new Date();
  });

  useEffect(() => {
    if (!analysisDate) return;
    const d = dayjs(analysisDate);
    if (d.isValid()) setStartDate(d.toDate());
  }, [analysisDate]);

  function handleChangeDate(date) {
    if (!date) return;

    if (typeof date === "string") {
      setAnalysisDate(date);
      const d = dayjs(date);
      if (d.isValid()) setStartDate(d.toDate());
      return;
    }

    if (date instanceof Date && !Number.isNaN(date.getTime())) {
      const iso = formatDateInEN(date);
      setAnalysisDate(iso);
      setStartDate(date);
    }
  }

  const safeAnalysisDate = useMemo(() => {
    if (analysisDate) return analysisDate;
    return formatDateInEN(startDate);
  }, [analysisDate, startDate]);

  return (
    <div className="tricho-topbar tricho-topbar--white">
      {/* Linha 1 */}
      <Row className="align-items-start g-2">
        <Col xs={12} md>
          <div className="tricho-topbar__titleRow">
            <h4 className="m-0 tricho-topbar__title">{title}</h4>
            <Badge bg={badgeVariant} className="tricho-topbar__badge">
              {badgeLabel}
            </Badge>
          </div>

          <div className="tricho-topbar__subtitle">
            Marque unidades foliculares e gere insights com visual limpo.
          </div>
        </Col>

        <Col xs={12} md="auto" className="tricho-topbar__right">
          <Form.Select
            size="sm"
            value={mode}
            onChange={(e) => onChangeMode(e.target.value)}
            className="tricho-topbar__select"
          >
            <option value="BASIC">Modo básico</option>
            <option value="ADV">Modo avançado</option>
          </Form.Select>

          <AppButton
            size="sm"
            variant="danger"
            isOutline
            onClick={onReset}
            name="Reiniciar"
          />
        </Col>
      </Row>

      {/* Divider */}
      <div className="tricho-topbar__divider" />

      {/* Linha 2 */}
      <Row className="g-2">
        <Col xs={12} lg={6}>
          <AppInputV2
            label="Nome da análise"
            name="name"
            isRequired
            errors={[]}
            value={analysisName}
            placeholder="Ex: Avaliação inicial / Retorno 30 dias"
            onChange={(e) => setAnalysisName(e.target.value)}
          />
        </Col>

        <Col xs={12} sm={6} lg={6}>
          <CalendarInputV2
            selectionMode="single"
            setDates={setStartDate}
            changeDates={handleChangeDate}
            values={startDate}
            name="date"
            label="Data da análise"
            className="w-100"
          />
          {/* se você quiser usar o safeAnalysisDate em algum lugar, ele está aqui:
              {safeAnalysisDate}
          */}
        </Col>

     <div>
     <Col xs={12} sm={12} lg={12}>
          <AppButton
            size="sm"
            name="Salvar"
            onClick={onSave}
            disabled={!canSave}
          />
        </Col>
     </div>
      </Row>
    </div>
  );
}